import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function EventsItemsListCtrl ($scope, $state, $stateParams, $translate, events, mechanic) {
  $scope.loaded = true;
  $scope.date = $stateParams.date;
  $scope.mechanic = mechanic || {
    display_name: 'Unassigned'
  };

  $scope.events = events;

  $scope.tableSettings = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        }
      },
      {
        field : 'plate_number',
        header: {
          text: $translate.instant('VEHICLE_SPACE.VEHICLE')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('BOOKING_SPACE.JOB')
        }
      },
      {
        field : 'estimated_hours',
        header: {
          text: $translate.instant('BOOKING_SPACE.ESTIMATED_HOURS')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewEvent(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('BOOKING_SPACE.NO_BOOKINGS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewEvent(event.row)
  };

  $scope.viewEvent = function (event) {
    $state.go('app.event', {
      customer_id: event.customer_id,
      vehicle_id : event.vehicle_id,
      id         : event.event_id
    });
  };

}